<template>
    <!-- project area start -->
    <div class="project-area half-bg-top pd-top-115">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-lg-6 col-md-10">
                    <div class="section-title style-white text-center">
                        <h5 class="sub-title double-border">Work Process</h5>
                        <h2 class="title">How to work it</h2>
                        <p class="content">IT processes are some of the most critical processes in any business or organization.</p>
                    </div>
                </div>
            </div>
            <div class="project-slider slider-control-round owl-carousel">
                <div class="item">
                    <div class="single-project-inner">
                        <div class="thumb">
                            <a class="icon swp-readmore-arrow swp-image-popup" href="assets/img/project/6.webp">
                                <i class="fas fa-search-minus"></i>
                            </a>
                            <img src="assets/img/project/6.webp" alt="img">
                        </div>
                        <div class="details-wrap">
                            <div class="details-inner">
                                <h3><a href="project-details.html">Research</a></h3>
                                <p>Research IT focuses on Research Data Management and e-Infrastructure, with the aim of supporting and relieving Utrecht University academics in conducting transparent, sustainable and ethically qualified research. </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="item">
                    <div class="single-project-inner">
                        <div class="thumb">
                            <a class="icon swp-readmore-arrow swp-image-popup" href="assets/img/project/6.webp">
                                <i class="fas fa-search-minus"></i>
                            </a>
                            <img src="assets/img/project/6.webp" alt="img">
                        </div>
                        <div class="details-wrap">
                            <div class="details-inner">
                                <h3><a href="project-details.html">Ideation</a></h3>
                                <p>process where you generate ideas and solutions through sessions</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="item">
                    <div class="single-project-inner">
                        <div class="thumb">
                            <img src="assets/img/project/6.webp" alt="img">
                            <a class="icon swp-readmore-arrow swp-image-popup" href="assets/img/project/6.webp">
                                <i class="fas fa-search-minus"></i>
                            </a>
                        </div>
                        <div class="details-wrap">
                            <div class="details-inner">
                                <h3><a href="project-details.html">Design</a></h3>
                                <p>Don't engineer by coincidence-design it like you mean it! Filled with practical techniques, Design It! </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="item">
                    <div class="single-project-inner">
                        <div class="thumb">
                            <img src="assets/img/project/6.webp" alt="img">
                            <a class="icon swp-readmore-arrow swp-image-popup" href="assets/img/project/6.webp">
                                <i class="fas fa-search-minus"></i>
                            </a>
                        </div>
                        <div class="details-wrap">
                            <div class="details-inner">
                                <h3><a href="project-details.html">Development</a></h3>
                                <p>During this phase, the concept is refined to the point where a detailed service blueprint representing the implementation plan for the service can be produced.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="item">
                    <div class="single-project-inner">
                        <div class="thumb">
                            <img src="assets/img/project/6.webp" alt="img">
                            <a class="icon swp-readmore-arrow swp-image-popup" href="assets/img/project/6.webp">
                                <i class="fas fa-search-minus"></i>
                            </a>
                        </div>
                        <div class="details-wrap">
                            <div class="details-inner">
                                <h3><a href="project-details.html">Iteration</a></h3>
                                <p>The iterative process is a technique research and development teams use to help them optimize their products, services and business processes.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- project area end -->
</template>

<script>
    export default {
        name: "Project"
    }
</script>